module.exports = __webpack_public_path__ + "static/media/img_nuestramadre.680f0991.jpg";